import { Record } from 'immutable';

const RAv2HomeworkResultSummaryRecord = Record({
  studentId: undefined,
  avgCompletion: 0,
  avgAccuracy: 0,
  totalRecorded: 0,
  totalStoryRead: 0,
});

class RAv2HomeworkResultSummary extends RAv2HomeworkResultSummaryRecord { }

const toNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

RAv2HomeworkResultSummary.create = (data = {}) =>
  new RAv2HomeworkResultSummary({
    studentId: data.studentId,
    avgCompletion: toNumber(data.avgCompletion),
    avgAccuracy: toNumber(data.avgAccuracy),
    totalRecorded: toNumber(data.totalRecorded),
    totalStoryRead: toNumber(data.totalStoryRead),
  });

export default RAv2HomeworkResultSummary;



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultSummary/model.js